<template>
  <notification-card
    :iso-timestamp="n['@timestamp']"
    :icon="icon"
    :iconClass="iconClass">

    <!-- custom buttons -->
    <template #left>

      <!-- conversation snapshot -->
      <SnapshotButton v-if="isScrape" :n="n"/>
      <!-- eo:conversation snapshot -->

    </template>
    <!-- eo:custom buttons -->

    <template #menu>
      <NotificationMenu :n="n" variant="success" />
    </template>

    <!-- attachments and attachment menu -->
    <template v-if="attCount > 0" #attachments_menu>
      <AttachmentsMenu :n="n" />
    </template>
    <template v-if="attCount > 0" #attachments>
      <AttachmentsViewer :n="n" />
    </template>
    <!-- eo:attachments and attachment menu -->

    <!-- title -->
    <template #title>
      <b-tooltip v-if="isNotification" type="is-dark" label="Notification Received" class="mr-2">
        <font-awesome-icon icon="bell" class="animate__swing animate__animated animate__slow animate__infinite" />
      </b-tooltip>
      <b-tooltip v-if="isBroadcast" type="is-success" :label="meta['chat-name']" class="mr-2">
        <font-awesome-icon icon="bullhorn" class="animate__tada animate__animated animate__slow animate__infinite has-text-success" />
      </b-tooltip>
      <b-tooltip v-if="isSystemOrInfoMessage" type="is-dark" label="System Message" class="mr-2">
        <font-awesome-icon icon="circle-info" class="has-text-dark animate__animated animate__infinite animate__flash animate__slow" />
      </b-tooltip>
      <b-tooltip v-if="isForwarded" type="is-dark" label="Message Forwarded" class="mr-2">
        <font-awesome-icon icon="share" class="has-text-dark" />
      </b-tooltip>
      <b-tooltip v-if="isCall" type="is-info" label="VoIP related" class="mr-2">
        <font-awesome-icon :icon="meta.content.indexOf(' ended') !== -1 ? 'phone-slash' : 'phone-flip'" class="has-text-info" />
      </b-tooltip>
      <strong v-if="meta.deleted === '1'">DELETED:&nbsp;</strong>
      {{ title }}
    </template>
    <!-- eo:title -->
    
    <!-- conversation snapshot details card -->
    <ConversationSnapshotDetailsCard v-if="isScrape" :n="n"/>
    <!-- eo:conversation snapshot details card -->

    <!-- default view -->
    <div v-else>
      <b-field grouped group-multiline>
        <!-- chat-name / other party -->
        <div v-if="!isBroadcast" class="control">
          <b-taglist attached>
              <b-tag size="is-medium" type="is-success">{{ meta['contact-name'] || meta['chat-name'] || '?' }}</b-tag>
              <b-tag v-if="meta['contact-phone-number']" size="is-medium" type="is-dark">{{ meta['contact-phone-number'] }}</b-tag>
          </b-taglist>
        </div>
        <!-- eo:chat-name / other party -->
        <!-- group -->
        <div v-if="meta['group-chat'] === '1'" class="control">
          <b-taglist attached>
              <b-tag size="is-medium" type="is-success">Group</b-tag>
              <b-tag size="is-medium" type="is-dark">{{ meta['chat-name'] }}</b-tag>
          </b-taglist>
        </div>
        <!-- group -->
      </b-field>
      <p :class="textClass">{{ n.metaData.content }}</p>
    </div>
    <!-- eo:default view -->

  </notification-card>
</template>

<script>
import { chatAppIcon, chatAppVariant, notificationEventTypes, messageForwardedEventTypes, massSentMessageEventType } from '@/services/chats/consts'
import { isScrape } from '@/services/chats/snapshots'
import attachments from '@/services/attachments'
import SnapshotButton from '@/components/SnapshotButton.vue'
import ConversationSnapshotDetailsCard from './ConversationSnapshot.vue'
import { pascalToHuman } from '@/services/text/humanify'

export default {
  components: { SnapshotButton, ConversationSnapshotDetailsCard },
  props: {
    n: Object
  },
  data () {
    return {
      showSnapshot: false
    }
  },
  computed: {
    meta () { return this.n.metaData },
    isCall () { return (this.meta.content || '').indexOf(' call') !== -1 },
    packageName () { return this.meta['package-name'] },
    icon () { return chatAppIcon(this.packageName) },
    iconClass () { return `has-text-${chatAppVariant(this.packageName)}` },
    title () { 
      if (this.isSystemOrInfoMessage) return 'APP INFO MESSAGE'
      return pascalToHuman(this.meta['policy-set-rule'] || this.meta.eventType)
    },
    attCount () { return attachments.parse(this.n).all.length },
    isNotification () { return notificationEventTypes.includes(this.meta.eventType) },
    isBroadcast () { return this.meta.eventType == massSentMessageEventType },
    isScrape () { return isScrape(this.n) },
    isForwarded () { return messageForwardedEventTypes.includes(this.meta.eventType) },
    isSystemOrInfoMessage () { 
      if (this.meta['im-type'] === 'info') {
        return true
      }
      if ((this.meta['direction']||'').toLowerCase() === 'system') {
        return true
      }
      return false
    },
    textClass () {
      if (this.isSystemOrInfoMessage) return 'has-text-centered notification is-white'
      return null
    }
  }
}
</script>